export default __webpack_public_path__ + "static/media/project-icon.49b08a49.png";